// Exploración a todo color (30-10-2026): cada cine tiene SU color, el mismo en
// toda la web (horarios de la ficha, cartelera, página del cine). Sirve para
// reconocerlo de un vistazo, como la línea de un plano de metro.
export type Tone = { bg: string; fg: string; duo: string };

const TONES: Record<string, Tone> = {
  orange: { bg: "bg-rc-orange", fg: "text-rc-navy", duo: "bg-rc-orange" },
  lime: { bg: "bg-rc-lime", fg: "text-rc-navy", duo: "bg-rc-lime" },
  pink: { bg: "bg-rc-pink", fg: "text-rc-navy", duo: "bg-rc-pink" },
  blue: { bg: "bg-rc-blue", fg: "text-white", duo: "bg-rc-blue" },
  lavender: { bg: "bg-rc-lavender", fg: "text-rc-navy", duo: "bg-rc-lavender" },
  violet: { bg: "bg-rc-violet", fg: "text-white", duo: "bg-rc-violet" },
};

/** Asignación fija por sala (los nueve cines de la tarifa). */
const BY_CINEMA: Record<string, keyof typeof TONES> = {
  "Cinemes Texas": "orange",
  "Zumzeig Cinema": "pink",
  "Cinema Edison": "blue",
  "Cinemes Girona": "lime",
  "Cines ABC El Saler": "orange",
  "Cines ABC Gran Turia": "lime",
  "Cines ABC Park": "pink",
  "Cines Babel": "blue",
  "Cines Lys": "violet",
};
const ORDER = Object.keys(TONES) as (keyof typeof TONES)[];

export function cinemaTone(name: string | null | undefined): Tone {
  const key = name ? BY_CINEMA[name] : undefined;
  if (key) return TONES[key];
  let h = 0;
  for (const ch of name ?? "") h = (h * 31 + ch.charCodeAt(0)) | 0;
  return TONES[ORDER[Math.abs(h) % ORDER.length]];
}
